import { Star } from "lucide-react";
import { useLang } from "@/context/LanguageContext";
import { useReviews } from "@/lib/useReviews";

export function HeroRating() {
  const { t } = useLang();
  const { avg, total, hasAny } = useReviews();
  if (!hasAny) return null;
  return (
    <div className="inline-flex items-center gap-3 mt-8 border border-[#FFB800]/30 bg-[#FFB800]/5 px-4 py-2" data-testid="hero-rating">
      <span className="inline-flex gap-0.5">
        {[1, 2, 3, 4, 5].map((i) => (
          <Star key={i} className={`w-4 h-4 ${i <= Math.round(avg) ? "fill-[#FFB800] text-[#FFB800]" : "text-zinc-600"}`} />
        ))}
      </span>
      <span className="font-display font-900 text-white text-lg leading-none">{avg.toFixed(1)}</span>
      <span className="font-mono-tech text-[11px] uppercase tracking-wider text-zinc-400">{total} {t("reviews.count_label")}</span>
    </div>
  );
}
